import { useIntl } from 'react-intl';

import { Tooltip, Button } from '@ets/design-system';
import { useDispatch } from '_common/hooks';
import { markAllNotificationsAsRead } from '../NotificationsSlice';
import { toast } from 'utils/toast';

type MarkAllButtonProps = {
  enabled: boolean;
};

const MarkAllButton = ({ enabled }: MarkAllButtonProps) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'ALL_AVAILABLE_NOTIFICATIONS_ARE_READ' })}
      placement="bottom"
      visible={!enabled}
      testId="notifications-button-mark-all-as-read"
    >
      <Button
        size="s"
        variant="link"
        onClick={() =>
          dispatch(markAllNotificationsAsRead()).then(() => {
            toast({
              variant: 'success',
              title: 'ALL_NOTIFICATIONS_READ',
              message: 'YOU_HAVE_MARKED_ALL_UNREAD_NOTIFICATIONS_AS_READ',
            });
          })
        }
        disabled={!enabled}
        testId="notifications-button-mark-all-as-read"
        style={{ margin: '0 0.5rem 0 0' }}
      >
        {intl.formatMessage({ id: 'MARK_ALL_AS_READ' })}
      </Button>
    </Tooltip>
  );
};

export default MarkAllButton;
